module.exports = __webpack_public_path__ + "static/media/  (172).807a7633.jpg";